






































































import Vue from 'vue'
export default Vue.extend({
    props: {
        comment: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disableSubmit: {
            type: Boolean,
            default: false
        },
        save: {
            type: Boolean,
            default: false
        },
        sending: {
            type: Boolean,
            default: false
        }
    }
})
